import { Controller } from "stimulus";

class SectionLayoutController extends Controller {
  static targets = ["keyline", "background"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (this.keylineTarget.checked) {
      Array.from(this.backgroundTargets).map((t) => t.classList.add("hidden"));
    } else {
      Array.from(this.backgroundTargets).map((t) =>
        t.classList.remove("hidden"),
      );
    }
  }
}

export default SectionLayoutController;
